import { render, staticRenderFns } from "./page-search.vue?vue&type=template&id=0f08154e&scoped=true&"
import script from "./page-search.vue?vue&type=script&lang=js&"
export * from "./page-search.vue?vue&type=script&lang=js&"
import style0 from "./page-search.vue?vue&type=style&index=0&id=0f08154e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f08154e",
  null
  
)

export default component.exports